import './ui/tokens.css'
import './ui/base.css'
import './ui/components.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { applyStartParam, createAppRouter, queryClient } from './App.tsx'
import { API_MOCK, setAuthInitData, setWebMode } from './api/client.ts'
import { WebLogin } from './screens/WebLogin.tsx'
import { initTelegram } from './telegram/sdk.ts'

async function bootstrap(): Promise<void> {
  const container = document.getElementById('root')
  if (!container) return
  const root = createRoot(container)

  const env = await initTelegram()
  setAuthInitData(env.initDataRaw)

  // Вне Telegram — сайт CRM: вход через бота, сессия в cookie (демо-сборка с моками работает и так)
  if (!env.ready && !API_MOCK) {
    const signedIn = await fetch('/api/v1/me', { headers: { Accept: 'application/json' } })
      .then((r) => r.ok)
      .catch(() => false)
    if (!signedIn) {
      root.render(<WebLogin />)
      return
    }
    setWebMode(true)
    document.title = 'OVO CRM'
    // На сайте первой открывается главная: профиль, сводка дня, доска задач и заметки
    if (window.location.pathname === '/') window.history.replaceState(null, '', '/home')
  }

  const router = createAppRouter()
  applyStartParam(router, env.startParam)

  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}

void bootstrap()
